import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {FlattenOperatorParameters} from "#template/nodes/geometry-graph/attribute/flatten-operator/geometry-flatten-operator-node"
import {
    GeometryFlattenOperatorNode,
    flattenOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/flatten-operator/geometry-flatten-operator-node"

const definition: TemplateNodeDefinition<FlattenOperatorParameters> = {
    nodeClass: "CurveGeometryFlattenOperator",
    validation: {
        parameters: flattenOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryFlattenOperator extends GeometryFlattenOperatorNode implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
